// React
import * as React from 'react'

class Footer extends React.Component {
  /**
   * Render the main content
   * @returns {any}
   */
  render() {
    return <div className="PageViewFooter">{this.props.children}</div>
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/presentations/views/PageView/Footer.tsx